(function () {
  'use strict';

  function initBar(root) {
    if (!root || root._newbarInited) return;
    root._newbarInited = true;

    var sectionId        = root.getAttribute('data-section-id') || '';
    var cookieName       = 'newbar_dismissed_' + sectionId;
    var showCloseButton  = root.getAttribute('data-close-button') === 'true';
    var enableCookie     = root.getAttribute('data-cookie-dismiss') === 'true';
    var dismissDays      = parseInt(root.getAttribute('data-dismiss-days') || '7', 10);
    if (isNaN(dismissDays) || dismissDays <= 0) dismissDays = 7;

    function getCookie(name) {
      var parts = ('; ' + document.cookie).split('; ' + encodeURIComponent(name) + '=');
      return parts.length === 2 ? parts.pop().split(';').shift() : null;
    }
    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
        '; expires=' + d.toUTCString() + '; path=/; samesite=lax';
    }

    if (enableCookie) {
      if (getCookie(cookieName) === '1') {
        root.setAttribute('data-dismiss-init', '1');
        return;
      }
      root.setAttribute('data-dismiss-init', '0');
    } else {
      root.setAttribute('data-dismiss-init', '0');
    }

    var closeBtn = root.querySelector('.newbar-close');
    if (closeBtn && showCloseButton) {
      closeBtn.addEventListener('click', function () {
        if (enableCookie) setCookie(cookieName, '1', dismissDays);
        root.style.display = 'none';
      });
    }

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length === 0) return;

    var autoplay     = root.getAttribute('data-autoplay') === 'true';
    var rotateMs     = parseInt(root.getAttribute('data-interval') || '4000', 10);
    var pauseOnHover = root.getAttribute('data-pause-on-hover') === 'true';
    var duration     = parseInt(root.getAttribute('data-duration') || '350', 10);
    var autoHeight   = root.getAttribute('data-auto-height') === 'true';
    var slidesWrap   = root.querySelector('.newbar-slides');
    var mobileHeightQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

    root.style.setProperty('--newbar-duration', duration + 'ms');

    function isMobileHeightMode() {
      return mobileHeightQuery ? mobileHeightQuery.matches : window.innerWidth <= 768;
    }

    function setMobileUniformHeight(height) {
      slides.forEach(function (item) {
        var inner = item.querySelector('.newbar-inner');
        item.style.minHeight = height ? height + 'px' : '';
        if (inner) inner.style.minHeight = height ? height + 'px' : '';
      });
    }

    function measureMobileUniformHeight() {
      var maxHeight = 0;
      setMobileUniformHeight(0);
      visibleSlides().forEach(function (item) {
        var inner = item.querySelector('.newbar-inner');
        maxHeight = Math.max(maxHeight, (inner || item).offsetHeight);
      });
      return maxHeight;
    }

    function setWrapHeight(slide) {
      if (!autoHeight || !slidesWrap || !slide) return;
      if (isMobileHeightMode()) {
        var uniformHeight = measureMobileUniformHeight();
        if (uniformHeight > 0) {
          setMobileUniformHeight(uniformHeight);
          slidesWrap.style.height = uniformHeight + 'px';
        }
        return;
      }
      setMobileUniformHeight(0);
      slidesWrap.style.height = slide.offsetHeight + 'px';
    }

    function bindButtonHover(slide) {
      var btn = slide.querySelector('[data-btn]');
      if (!btn) return;
      var bg  = btn.getAttribute('data-btn-bg'),    tx  = btn.getAttribute('data-btn-text'),
          bd  = btn.getAttribute('data-btn-border'), bgH = btn.getAttribute('data-btn-bg-hover'),
          txH = btn.getAttribute('data-btn-text-hover'), bdH = btn.getAttribute('data-btn-border-hover');
      btn.addEventListener('mouseenter', function () {
        if (bgH) btn.style.background  = bgH;
        if (txH) btn.style.color       = txH;
        if (bdH) btn.style.borderColor = bdH;
      });
      btn.addEventListener('mouseleave', function () {
        if (bg) btn.style.background  = bg;
        if (tx) btn.style.color       = tx;
        if (bd) btn.style.borderColor = bd;
      });
    }
    slides.forEach(bindButtonHover);

    function setDigits(el, value, minLen) {
      if (!el) return;
      var str = String(value == null ? '' : value);
      if (minLen) str = str.padStart(minLen, '0');
      el.innerHTML = str.split('').map(function (ch) {
        return '<span class="newbar-digit">' + ch + '</span>';
      }).join('');
    }

    function parseEnd(endStr) {
      if (!endStr) return null;
      var d = new Date(String(endStr).replace(' ', 'T'));
      return isNaN(d.getTime()) ? null : d;
    }

    slides.forEach(function (slide) {
      if (slide.getAttribute('data-enable-countdown') !== 'true') return;
      var end = parseEnd(slide.getAttribute('data-end'));
      if (!end) return;

      var hideExpired = slide.getAttribute('data-hide-expired') === 'true';
      var dd = slide.querySelector('[data-dd]'), hh = slide.querySelector('[data-hh]'),
          mm = slide.querySelector('[data-mm]'), ss = slide.querySelector('[data-ss]');
      var cdTimer = null;

      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          setDigits(dd, 0, 2); setDigits(hh, 0, 2);
          setDigits(mm, 0, 2); setDigits(ss, 0, 2);
          if (hideExpired && slide.style.display !== 'none') {
            clearInterval(cdTimer);
            slide.style.display = 'none';
            slide.setAttribute('data-expired', '1');
            ensureActive();
            checkAllGone();
          }
          return;
        }
        var total = Math.floor(diff / 1000);
        setDigits(dd, Math.floor(total / 86400), 2);
        setDigits(hh, Math.floor((total % 86400) / 3600), 2);
        setDigits(mm, Math.floor((total % 3600) / 60), 2);
        setDigits(ss, total % 60, 2);
      }

      tick();
      cdTimer = setInterval(tick, 1000);
    });

    function visibleSlides() {
      return slides.filter(function (s) { return s.style.display !== 'none'; });
    }

    function checkAllGone() {
      if (visibleSlides().length === 0) {
        root.style.display = 'none';
        stopAutoplay();
      }
    }

    function ensureActive() {
      var vis = visibleSlides();
      if (vis.length === 0) return;
      var current = root.querySelector('[data-slide][data-active]');
      if (!current || current.style.display === 'none') {
        slides.forEach(function (s) { s.removeAttribute('data-active'); });
        vis[0].setAttribute('data-active', '');
        current = vis[0];
      }
      setWrapHeight(current);
    }

    function showByVisibleIndex(nextIdx, dir) {
      var vis = visibleSlides();
      if (vis.length === 0) return;
      if (nextIdx < 0) nextIdx = vis.length - 1;
      if (nextIdx >= vis.length) nextIdx = 0;

      var current   = root.querySelector('[data-slide][data-active]');
      var nextSlide = vis[nextIdx];
      if (!nextSlide || current === nextSlide) return;

      var isSlide = root.getAttribute('data-transition') === 'slide';
      dir = dir === -1 ? -1 : 1;

      if (!isSlide) {
        slides.forEach(function (s) {
          s.removeAttribute('data-active');
          s.removeAttribute('data-enter');
          s.removeAttribute('data-exit');
        });
        nextSlide.setAttribute('data-active', '');
        if (autoHeight) requestAnimationFrame(function () { setWrapHeight(nextSlide); });
        return;
      }

      slides.forEach(function (s) { s.removeAttribute('data-enter'); s.removeAttribute('data-exit'); });

      var enterX = dir > 0 ? '40px' : '-40px';
      var exitX  = dir > 0 ? '-40px' : '40px';
      nextSlide.style.setProperty('--nb-enter-x', enterX);
      if (current) current.style.setProperty('--nb-exit-x', exitX);

      if (current) current.setAttribute('data-exit', '');
      nextSlide.setAttribute('data-enter', '');
      void nextSlide.offsetHeight;

      requestAnimationFrame(function () {
        slides.forEach(function (s) { s.removeAttribute('data-active'); });
        nextSlide.setAttribute('data-active', '');
        if (autoHeight) requestAnimationFrame(function () { setWrapHeight(nextSlide); });

        var done = false;
        function cleanup() {
          if (done) return; done = true;
          nextSlide.removeAttribute('data-enter');
          if (current) current.removeAttribute('data-exit');
          nextSlide.removeEventListener('transitionend', onEnd);
        }
        function onEnd(e) { if (!e || e.target === nextSlide) cleanup(); }
        nextSlide.addEventListener('transitionend', onEnd);
        setTimeout(cleanup, duration + 60);
      });
    }

    function next() {
      var vis = visibleSlides();
      if (vis.length <= 1) return;
      var cur = root.querySelector('[data-slide][data-active]');
      var idx = vis.indexOf(cur);
      showByVisibleIndex((idx < 0 ? 0 : idx) + 1, +1);
    }
    function prev() {
      var vis = visibleSlides();
      if (vis.length <= 1) return;
      var cur = root.querySelector('[data-slide][data-active]');
      var idx = vis.indexOf(cur);
      showByVisibleIndex((idx < 0 ? 0 : idx) - 1, -1);
    }

    function refreshActiveHeight() {
      var active = root.querySelector('[data-slide][data-active]');
      if (!active) return;
      requestAnimationFrame(function () { setWrapHeight(active); });
    }

    var resizeTimer = null;
    function handleViewportChange() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshActiveHeight, 120);
    }

    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);
    root._newbarCleanup = function () {
      window.removeEventListener('resize', handleViewportChange);
      window.removeEventListener('orientationchange', handleViewportChange);
      if (resizeTimer) clearTimeout(resizeTimer);
    };

    ensureActive();
    checkAllGone();
    refreshActiveHeight();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshActiveHeight).catch(function () {});
    }

    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var autoTimer = null;
    function startAutoplay() { if (!autoplay || autoTimer) return; autoTimer = setInterval(next, rotateMs); }
    function stopAutoplay()  { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }

    if (visibleSlides().length > 0) { startAutoplay(); } else { root.style.display = 'none'; }
  }

  function initAll() {
    document.querySelectorAll('[data-newbar-root]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-newbar-root]');
    if (root) initBar(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-newbar-root]');
    if (root && typeof root._newbarCleanup === 'function') {
      root._newbarCleanup();
      root._newbarCleanup = null;
      root._newbarInited = false;
    }
  });
})();
